<template>
  <div>
    <div class="side-frame-success">
      <span style="font-size: 14px; color: #606266">{{
        $l('INDEX.form_label_tech_description') || '工艺说明'
      }}</span>
      <el-divider direction="vertical" v-if="!disabled"></el-divider>
      <b-button
        size="sm"
        class="ml-2"
        variant="outline-success"
        @click="$emit('openEditFormDialog', { type: 'add' })"
        v-if="!disabled"
      >
        {{ $l('INDEX.btn_tech_upload_file') || '上传文件' }}
      </b-button>
    </div>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
}

export default {
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    reload() {
      this.form = { ...initForm }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
